<template>
	<div class="additional-documentation-upload" redesign>
		<!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header" v-translate>Upload Additional Documentation</h1>
    </div>

    <!-- Loading spinner -->
    <div v-if="loading" class="form-container">
      <LoadSpinner :color="`#${organizationDetails.darkBrandColor}`" />
    </div>

    <!-- Receipt upload -->
    <div v-if="!loading" class="form-container additional-documentation-upload-form">
	    <!-- Upload form -->
			<div v-if="!error && request" class="form-field">
				<DocumentUpload
          :request="request"
          :documentList.sync="documents"
          :loading="loading"
          docDetailType="REQUEST"
          @documents-changed="onDocumentsChanged($event, request.id)"
          :darkText="true"
          :disableDelete="true"
        />
			</div>

			<!-- Invalid request / error message -->
			<div v-else class="form-field">
				<div class="form-field-container error-container">
					<div class="tooltip-icon">
            <img src="@/assets/icons/error-icon.png" />
          </div>
          <div class="tooltip">
            <h4 class="tooltip-header" v-translate>Couldn't Retrieve Your Request</h4>
            <span class="tooltip-text" v-translate>
              The specified request could not be retrieved. Please try again later, or contact support for assistance.
            </span>
          </div>
				</div>
			</div>
    </div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Request from '@/services/requests'
import Document from '@/services/documents'
import DocumentUpload from '@/components/requests/DocumentUpload'
import LoadSpinner from '@/components/LoadSpinner'
import SubmitButton from '@/components/requests/SubmitButton'
import UserEvent from '@/services/userEvents'
import { formatText, formatValue } from '@/services/utils'

export default {
  name: 'AdditionalDocumentationUpload',
  components: {
    DocumentUpload,
    LoadSpinner,
    SubmitButton,
  },
  data() {
  	return {
  		loading: false,
  		error: false,
  		requestId: null,
  		request: null,
  		documents: [],
  		killList: [],
  	}
  },
  async created() {
  	this.loading = true
  	this.requestId = this.$route.params.id
  	if(this.requestId) {
  		await this.refresh()
  	} else {
  		this.error = true
  	}
  	this.loading = false
  },
  methods: {
  	async refresh() {
      const request = await Request.api.retrieve(this.requestId)
      this.request = request
      this.documents = request.documentsRef
      this.$store.dispatch('updateCurrentRequest', request)
    },
    async onDocumentsChanged(documentList, requestId) {
      this.loading = true

      //this.eventsTracker('uploaded-or-changed-upload-for-request', `Request ID: ${this.requestId}`)
      // Replace all documents for this particular expense with the newest set
      this.documents = documentList

      await this.updateDocuments()
      this.loading = false

      // Create a user event indicating additional documentation has been uploaded, this will
      // trigger a message to the GMs to view the request
      const userEvent = UserEvent.create({
        eventType: UserEvent.options.ADDITIONAL_DOCUMENTS_UPLOADED,
        user: this.user.id,
        request: this.request.id,
        verificationAttempts: null,
      })
      await UserEvent.api.create(userEvent)
    },
    async updateDocuments() {
      // Collect expense-docs into an array of arrays
      const documentList = Object.values(this.documents)

      // Loop through all documents from each expense
      const promiseList = []
      documentList.forEach(doc => {
        const index = documentList.indexOf(doc)

        // If document does not have an ID, it doesn't yet exist in the DB - so we need to create it
        if (!doc.id) {
          promiseList.push(
            Document.api.create(doc).then(document => (documentList[index] = document)),
          )
        }
      })

      // Delete every document the user removed
      this.killList.forEach(doc => {
        promiseList.push(Document.api.delete(doc))
      })

      // Wait for all Documents to be modified before updating Request
      await Promise.all(promiseList)
      this.killList = []

      // Modify the request in state
      //this.setDocs()
    },
  },
  computed: {
  	...mapState([
  		'user',
  		'organizationDetails',
  	]),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/flex-box';
@import '@/styles/text';
@import '@/styles/grant-circles';

.additional-documentation-upload {
  display: flex;
  flex-direction: column;

  .additional-documentation-upload-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
 }
</style>